import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React, { useState } from 'react';
import generateUniqueId from 'lodash.uniqueid';
import Input from '../input';
import { ReactComponent as UploadIcon } from '../static-icons/upload.svg';
import DefaultTheme from './theme';
export var FileInputTheme = DefaultTheme;
/*::
import type { ElementType, Node } from 'react';
import type { StyledComponent } from 'styled-components';
import type { InputThemeType } from '../input';

export type FileInputThemeType = {|
  Main: * => Node;
  Label: * => Node;
  Input: InputThemeType;
  FileInput: * => Node;
|};

type Props = {|
  className?: string;
  accept?: string;
  value?: null | File | File[],
  onChange?: (value: File | File[]) => void,
  icon?: ElementType;
  disabled?: boolean;
  error?: boolean;
  multiple?: boolean;
  onClick?: (e: any) => void;
  onKeyDown?: (e: any) => void;
  onFocus?: (e: FocusEvent) => void;
  onBlur?: (e: FocusEvent) => void;
  theme?: FileInputThemeType,
  rest?: any,
|};
*/

var FileInput = function FileInput(_ref
/*: Props */
, ref) {
  var _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? UploadIcon : _ref$icon,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      _ref$accept = _ref.accept,
      accept = _ref$accept === void 0 ? null : _ref$accept,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return undefined;
  } : _ref$onChange,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {
    return undefined;
  } : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {
    return undefined;
  } : _ref$onBlur,
      rest = _objectWithoutPropertiesLoose(_ref, ["icon", "className", "disabled", "error", "value", "multiple", "accept", "onChange", "theme", "onFocus", "onBlur"]);

  var _useState = useState(generateUniqueId('file-input-')),
      id = _useState[0];

  var onChangeInternal = function onChangeInternal(e
  /*: SyntheticInputEvent<HTMLInputElement> */
  ) {
    if (multiple) {
      var fileArray = Array.prototype.slice.call(e.target.files);
      onChange(fileArray);
      return;
    }

    onChange(e.target.files[0]);
  }; // eslint-disable-next-line arrow-body-style


  var displaySingleValue = function displaySingleValue(val
  /*: null | File */
  ) {
    return val ? val.name : '';
  };

  var displayArrayValue = function displayArrayValue(values
  /*: null | File[] */
  ) {
    if (!values) return '';
    return values.map(function (v) {
      return v.name;
    }).join(', ');
  };

  return /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    className: className
  }, rest), /*#__PURE__*/React.createElement(theme.Label, {
    htmlFor: id
  }, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    readOnly: true,
    disabled: disabled,
    error: error,
    icon: icon,
    value: Array.isArray(value) ? displayArrayValue(value) : displaySingleValue(value) // label comes from form element
    ,
    theme: theme.Input
  })), /*#__PURE__*/React.createElement(theme.FileInput, {
    id: id,
    type: "file",
    accept: accept,
    multiple: multiple,
    disabled: disabled,
    onChange: onChangeInternal,
    onFocus: onFocus,
    onBlur: onBlur,
    ref: ref
  }));
};

export default /*#__PURE__*/React.forwardRef
/*:: <Props, StyledComponent> */
(FileInput);